// https://medium.com/@ashokraju/using-segment-io-analytics-js-with-single-page-react-typescript-app-a8c12b4816c4

/// <reference types="@types/segment-analytics" />

declare global {
  // tslint:disable-next-line
  interface Window {
    analytics: SegmentAnalytics.AnalyticsJS;
  }
}

export const load = () => {
  window.analytics.load("iVNk30U3cN38FB89oXZnAUFsk12XjHlw");
};

export const page = (path: string) => {
  window.analytics.page(path);
};

export const track = (name: string, properties?: object) => {
  window.analytics.track(name, properties);
};

export const identify = (properties: object) => {
  window.analytics.identify(properties);
};



// WEBPACK FOOTER //
// ./src/analytics.ts